import type { BoardKanbanBoardState, BoardKanbanSliceState } from './boardKanban.types'

export const createEmptyBoardKanbanBoardState = (): BoardKanbanBoardState => ({
  board: null,
  boardItems: [],
  columns: [],
  stickers: [],
  loading: false,
  refreshing: false,
  pendingFetches: 0,
  error: null,
  cardsHasMore: false,
  cardsTotalCount: 0,
})

export const createInitialBoardKanbanState = (): BoardKanbanSliceState => ({
  byBoardId: {},
  reloadTokens: {},
})
